
import React from "react";
import styles from "../../assets/style.module.css";

export interface PageHeadProps {
    tag: string;
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
}

function PageHead({ tag, title, subtitle, children }: PageHeadProps) {
    return (<section className={styles["page-head"]}>
        <div className={styles["container"]}>
            <span className={styles["tag"]}>{tag}</span>
            <h1 className={styles["page-title"]}>{title}</h1>
            {subtitle && (<p className={styles["lead"]}>{subtitle}</p>)}
            {children}
        </div>
    </section>);
}

export default PageHead;
